import Vue from 'vue';
import App from './App.vue';
import AppPublic from './AppPublic.vue';
import router from './router';
import { Perfil } from '@/utils/constants.utils.js';

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/pt'
import 'regenerator-runtime/runtime';

import './components';
import './directives';
import './filters';

import { Message } from 'element-ui';

import './content/main.scss';

import { buscarUsuario } from '@/services/authenticate.service';

import VueApexCharts from 'vue-apexcharts';
Vue.use(VueApexCharts);

import moment from 'moment';
moment.locale('pt-br');
Vue.prototype.$moment = moment;

Vue.use(ElementUI, { locale });
window.Vue = Vue;

Vue.config.productionTip = false;
var publicURL = [];
var hashURL = window.location.hash;

router.options.routes.forEach(route => {
    const perfis = route.meta?.perfis ?? [];
    if (perfis.includes(Perfil.PUBLICO)) {
        publicURL.push('#' + route.path);
    }
});


if (publicURL.includes(hashURL)) {
    new Vue({
        router,
        render: (h) => h(AppPublic),
    }).$mount('#app');
} else {
    buscarUsuario().then((usuario) => {
        router.beforeEach((to, from, next) => {
            const perfis = to.meta?.perfis ?? [];
            if (perfis.includes(usuario.perfil)) {
                next();
            }
        });
        Vue.mixin({
            data() {
                return {
                    $usuario: usuario,
                };
            },
            methods: {
                $eu() {
                    return this.$root.$data.$usuario;
                },
                $dadosAssinanteExterno() {
                    return this.$root.$data.$usuario.dadosAssinanteExterno;
                },
                $modal(dados) {
                    ModalBus.$emit('open', dados);
                },
                $toast(dados) {
                    Message(dados);
                },
            },
        });
        new Vue({
            router,
            render: (h) => h(App),
        }).$mount('#app');
    });
}
